<ng-container *ngFor="let result of results">
  <ng-container [ngSwitch]="$any(result)?.type?.id">
    <ng-container *ngSwitchCase="'person'">
      <search-result-box
        *ngIf="!result?.title?.toLowerCase()?.includes('team')"
        class="lightmode"
        [route]="'/profile/' + result?.user?.id"
      >
        <ng-container owner>
          <search-title stylesAccentColour="publish-colour">
            <ng-container image>
              <elements-image-base
                size="30px"
                [imageUrl]="'https://profile-images.internal.brafton.com/profile-images/profile-image-' + result?.user?.id + '.jpg'"
              ></elements-image-base>
            </ng-container>
            <ng-container top>
              <span [innerHtml]="result?.highlight?.['owner'] || result?.user?.name"></span
            ></ng-container>
            <ng-container bottom> <mat-icon>people</mat-icon> {{$any(result)?.type?.name}} </ng-container>
          </search-title>
        </ng-container>
        <ng-container title>
          <span [innerHtml]="getTitle(result)"></span>
        </ng-container>
        <span [innerHtml]="getHighLightContent(result)"></span>
      </search-result-box>

      <search-result-box
        *ngIf="$any(result)?.source?.title?.toLowerCase().includes('team')"
        class="lightmode"
        [route]="'/team/' + $any(result)?.user?.id"
      >
        <ng-container owner>
          <search-title stylesAccentColour="publish-colour">
            <ng-container image>
              <elements-image-base size="30px" imageUrl="/assets/images/fallback/generic.png"></elements-image-base>
            </ng-container>
            <ng-container top>
              <span [innerHtml]="result?.highlight?.['owner'] || $any(result)?.organization.name"></span
            ></ng-container>
            <ng-container bottom> <mat-icon>people</mat-icon> Team </ng-container>
          </search-title>
        </ng-container>
        <ng-container title>
          <span [innerHtml]="result?.highlight?.['title'] || result?.title"></span>
        </ng-container>
        <span [innerHtml]="getHighLightContent(result)"></span>
      </search-result-box>
    </ng-container>

    <ng-container *ngSwitchCase="'project'">
      <ng-container *ngIf="$any(result)?.type !== 'StatementOfWork' && $any(result)?.project?.module !== 'Campaign'">
        <search-result-box class="lightmode" [result]="result">
          <ng-container owner>
            <search-title stylesAccentColour="tuscan-sun">
              <ng-container image>
                <mat-icon>dataset</mat-icon>
              </ng-container>
              < <ng-container top> {{result?.project?.name}} </ng-container>
              <ng-container bottom>
                <ng-container *ngIf="$any(result)?.organization">
                  <mat-icon>corporate_fare</mat-icon> {{$any(result)?.organization?.name}}
                </ng-container>
                <ng-container *ngIf="!$any(result)?.organization">
                  <mat-icon>dataset</mat-icon> {{$any(result)?.type?.name}}
                </ng-container>
              </ng-container>
            </search-title>
          </ng-container>
          <ng-container title>
            <span [innerHtml]="getTitle(result)"></span>
          </ng-container>
          <span [innerHtml]="getHighLightContent(result)"></span>
        </search-result-box>
      </ng-container>

      <!-- Need to Do this as Type is not Contract is Project -->
      <!-- <ng-container *ngIf="$any(result)?.type === 'StatementOfWork'">
          <search-result-box
            class="lightmode"
            [route]="result?.project?.id ? ('/sows/' + result?.project?.id) : undefined"
          >
            <ng-container owner>
              <search-title stylesAccentColour="not-tiffany">
                <ng-container image>
                  <mat-icon>receipt</mat-icon>
                </ng-container>
                <ng-container top>
                  <span [innerHtml]="result?.highlight?.['owner'] || $any(result)?.organization?.name"></span>
                </ng-container>
                <ng-container bottom> <mat-icon>receipt</mat-icon> Contract / Statement of Work </ng-container>
              </search-title>
            </ng-container>
            <ng-container title>
              <span [innerHtml]="result?.highlight?.['title'] || result?.title"></span>
            </ng-container>
            <span [innerHtml]="getHighLightContent(result)"></span>
          </search-result-box>
        </ng-container> -->

      <!-- Need to Do this as Type is not Campaign is in Project type -->
      <!-- <ng-container *ngIf="$any(result)?.type !== 'StatementOfWork' && $any(result)?.project?.module === 'Campaign'">
          <search-result-box
            class="lightmode"
            [route]="result?.project?.id ? ('/campaigns/' + result?.project?.id) : undefined"
          >
            <ng-container owner>
              <search-title stylesAccentColour="armageddon-dust">
                <ng-container image>
                  <mat-icon>campaign</mat-icon>
                </ng-container>
                <ng-container top>
                  <span [innerHtml]="result?.highlight?.['owner'] || $any(result)?.organization?.name"></span>
                </ng-container>
                <ng-container bottom> <mat-icon>campaign</mat-icon> Campaign </ng-container>
              </search-title>
            </ng-container>
            <ng-container title>
              <span [innerHtml]="result?.highlight?.['title'] || result?.title"></span>
            </ng-container>
            <span [innerHtml]="getHighLightContent(result)"></span>
          </search-result-box>
        </ng-container> -->
    </ng-container>

    <ng-container *ngSwitchCase="'organization'">
      <search-result-box class="lightmode" [route]="'/orgs/' + $any(result)?.organization.id">
        <ng-container owner>
          <search-title stylesAccentColour="slate">
            <ng-container image>
              <mat-icon>corporate_fare</mat-icon>
            </ng-container>
            <ng-container top> {{result?.project?.name}} </ng-container>
            <ng-container bottom>
              <ng-container *ngIf="$any(result)?.organization">
                <mat-icon>corporate_fare</mat-icon> {{$any(result)?.organization?.name}}
              </ng-container>
              <ng-container *ngIf="!$any(result)?.organization">
                <mat-icon>dataset</mat-icon> {{$any(result)?.type?.name}}
              </ng-container>
            </ng-container>
          </search-title>
        </ng-container>
        <ng-container title>
          <span [innerHtml]="getTitle(result)"></span>
        </ng-container>
        <span [innerHtml]="getHighLightContent(result)"></span>
      </search-result-box>
    </ng-container>

    <!-- <ng-container *ngSwitchCase="'contract'">
        <search-result-box class="lightmode">
          <ng-container owner>
            <search-title stylesAccentColour="not-tiffany">
              <ng-container image>
                <mat-icon>receipt</mat-icon>
              </ng-container>
              <ng-container top>
                <span [innerHtml]="result?.highlight?.['owner'] || $any(result)?.organization?.name"></span>
              </ng-container>
              <ng-container bottom> <mat-icon>receipt</mat-icon> {{$any(result)?.type?.name}} </ng-container>
            </search-title>
          </ng-container>
          <ng-container title>
            <span [innerHtml]="result?.highlight?.['title'] || result?.title"></span>
          </ng-container>
          <span [innerHtml]="getHighLightContent(result)"></span>
        </search-result-box>
      </ng-container> -->

    <ng-container *ngSwitchCase="'assetfile'">
      <search-result-box class="lightmode" [result]="result" routeSuffix="/gallery">
        <ng-container owner>
          <search-title stylesAccentColour="fresh-caught-salmon">
            <ng-container image>
              <mat-icon>folder</mat-icon>
            </ng-container>
            <ng-container top> {{result?.project?.name}} </ng-container>
            <ng-container bottom>
              <ng-container *ngIf="$any(result)?.organization">
                <mat-icon>corporate_fare</mat-icon> {{$any(result)?.organization?.name}}
              </ng-container>
              <ng-container *ngIf="!$any(result)?.organization">
                <mat-icon>dataset</mat-icon> {{$any(result)?.type?.name}}
              </ng-container>
            </ng-container>
          </search-title>
        </ng-container>
        <ng-container title>
          <span>{{$any(result)?.project?.name}} </span>
          <mat-icon>chevron_right</mat-icon>
          <span [innerHtml]="getTitle(result)"></span>
        </ng-container>
        <span [innerHtml]="getHighLightContent(result)"></span>
      </search-result-box>
    </ng-container>

    <ng-container *ngSwitchCase="'textset'">
      <search-result-box class="lightmode" [result]="result" [routeSuffix]="'/textset/'+ result?.textSet?.id">
        <ng-container owner>
          <search-title stylesAccentColour="not-tiffany">
            <ng-container image>
              <mat-icon>description</mat-icon>
            </ng-container>
            <ng-container top> {{result?.project?.name}} </ng-container>
            <ng-container bottom>
              <ng-container *ngIf="$any(result)?.organization">
                <mat-icon>corporate_fare</mat-icon> {{$any(result)?.organization?.name}}
              </ng-container>
              <ng-container *ngIf="!$any(result)?.organization">
                <mat-icon>dataset</mat-icon> {{$any(result)?.type?.name}}
              </ng-container>
            </ng-container>
          </search-title>
        </ng-container>
        <ng-container title>
          <span>{{$any(result)?.project?.name}} </span>
          <mat-icon>chevron_right</mat-icon>
          <span [innerHtml]="getTitle(result)"></span>
        </ng-container>
        <span [innerHtml]="getHighLightContent(result)"></span>
      </search-result-box>
    </ng-container>

    <!-- 
      <ng-container *ngSwitchCase="'content'">
        <search-result-box
          class="lightmode"
          [route]="result?.project?.id ? ('/produce/productions/' + result?.project?.id + '/gallery') : undefined"
        >
          <ng-container owner>
            <search-title stylesAccentColour="purple">
              <ng-container image>
                <mat-icon>picture_in_picture</mat-icon>
              </ng-container>
              <ng-container top>
                <span
                  [innerHtml]="result?.highlight?.['owner'] || $any(result)?.organization?.name || $any(result)?.project?.name "
                ></span
              ></ng-container>
              <ng-container bottom> <mat-icon>picture_in_picture</mat-icon> {{$any(result)?.type?.name}} </ng-container>
            </search-title>
          </ng-container>
          <ng-container title>
            <span>{{$any(result)?.project?.name}} </span>
            <mat-icon>chevron_right</mat-icon>
            <span [innerHtml]="result?.highlight?.['title'] || result?.title"></span>
          </ng-container>
          <span [innerHtml]="getHighLightContent(result)"></span>
        </search-result-box>
      </ng-container> -->

    <!-- <ng-container *ngSwitchCase="'campaign'">
        <search-result-box class="lightmode" [result]="result">
          <ng-container owner>
            <search-title stylesAccentColour="armageddon-dust">
              <ng-container image>
                <mat-icon>campaign</mat-icon>
              </ng-container>
              <ng-container top>
                <span [innerHtml]="result?.highlight?.['owner'] || $any(result)?.project?.name"></span>
              </ng-container>
              <ng-container bottom> <mat-icon>campaign</mat-icon> Campaign </ng-container>
            </search-title>
          </ng-container>
          <ng-container title>
            <span [innerHtml]="result?.highlight?.['title'] || result?.title"></span>
          </ng-container>
          <span [innerHtml]="getHighLightContent(result)"></span>
        </search-result-box>
      </ng-container> -->

    <ng-container *ngSwitchCase="'comment'">
      <search-result-box class="lightmode" [result]="result" routeSuffix="/messages">
        <ng-container owner>
          <search-title stylesAccentColour="orange">
            <ng-container image>
              <mat-icon>message</mat-icon>
            </ng-container>
            <ng-container top> {{result?.project?.name}} </ng-container>
            <ng-container bottom>
              <ng-container *ngIf="$any(result)?.organization">
                <mat-icon>corporate_fare</mat-icon> {{$any(result)?.organization?.name}}
              </ng-container>
              <ng-container *ngIf="!$any(result)?.organization">
                <mat-icon>dataset</mat-icon> {{$any(result)?.type?.name}}
              </ng-container>
            </ng-container>
          </search-title>
        </ng-container>

        <ng-container title>
          <span [innerHtml]="getTitle(result)"></span>
        </ng-container>
        <span [innerHtml]="getHighLightContent(result)"></span>
      </search-result-box>
    </ng-container>

    <ng-container *ngSwitchDefault>
      <search-result-box class="lightmode">
        <ng-container owner>
          <search-title stylesAccentColour="fresh-caught-salmon">
            <ng-container image>
              <mat-icon>question</mat-icon>
            </ng-container>
            <ng-container top> {{result?.project?.name}} </ng-container>
            <ng-container bottom>
              <ng-container *ngIf="$any(result)?.organization">
                <mat-icon>corporate_fare</mat-icon> {{$any(result)?.organization?.name}}
              </ng-container>
              <ng-container *ngIf="!$any(result)?.organization">
                <mat-icon>dataset</mat-icon> {{$any(result)?.type?.name}}
              </ng-container>
            </ng-container>
          </search-title>
        </ng-container>
        <ng-container title>
          <span [innerHtml]="getTitle(result)"></span>
        </ng-container>
        <span [innerHtml]="getHighLightContent(result)"></span>
      </search-result-box>
    </ng-container>
  </ng-container>
</ng-container>
